<template>
  <div>
    <the-headersider />

    <base-card class="card">
      <h2 class="title">Register Estate / Court</h2>

      <form @submit.prevent="createEstate">
        <div class="form-group">
          <label>Estate Name *</label>
          <input
            type="text"
            v-model.trim="formData.estateName"
            required
            placeholder="e.g. Green Valley Court"
          />
        </div>

        <div class="form-group">
          <label>Estate Area *</label>
          <input
            type="text"
            v-model.trim="formData.area"
            required
            placeholder="e.g. Pipeline, Syokimau"
          />
        </div>

        <div class="actions">
          <base-button :disabled="loading">
            {{ loading ? "Saving..." : "Register Estate" }}
          </base-button>
        </div>
      </form>
    </base-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      loading: false,
      formData: {
        estateName: "",
        area: "",
      },
    };
  },

  methods: {
    async createEstate() {
      this.loading = true;

      try {
        await axios.post(
          "https://api.roberms.com/gla/estate/registration/",
          this.formData
        );

        this.$router.replace("/estates");
      } catch (error) {
        alert("Failed to register estate. Please try again.");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.card {
  max-width: 600px;
  margin: auto;
}

.title {
  margin-bottom: 1rem;
  font-size: 1.4rem;
  font-weight: bold;
  color: #2c3e50;
}

.form-group {
  margin-bottom: 1rem;
}

label {
  font-weight: 600;
  display: block;
  margin-bottom: 0.3rem;
}

input {
  width: 100%;
  padding: 0.6rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  font: inherit;
}

input:focus {
  border-color: #3b82f6;
  outline: none;
  background-color: #f9fbff;
}

.actions {
  margin-top: 1.2rem;
  text-align: right;
}
</style>
